import { siteMeta } from "@/mocks/gossip";

const principles = [
  { icon: "ri-flashlight-line", title: "第一时间", text: "热点一出现就跟进，不做滞后搬运，蹲点现场的更新永远排在前面。" },
  { icon: "ri-price-tag-3-line", title: "标注来源", text: "官方口径、节目画面与网友反馈分开呈现，读者能看清每条信息的出处。" },
  { icon: "ri-shield-check-line", title: "保留疑问", text: "暂时无法确认的细节会明确写成待核实，不用肯定语气描述传闻。" },
  { icon: "ri-refresh-line", title: "持续蹲点", text: "事件有后续就补充进展，把零散消息连成完整脉络，而不是断章取义。" },
];

export default function AboutSection() {
  return (
    <section id="about" className="bg-background-50 py-16 md:py-24">
      <div className="shell grid grid-cols-1 items-center gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14">
        <div>
          <span className="text-xs font-medium uppercase tracking-[0.2em] text-primary-600">About Us</span>
          <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">关于{siteMeta.name}</h2>
          <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
            {siteMeta.name}是一个持续蹲点娱乐现场的吃瓜资讯站。我们不生产话题，只做那个守着屏幕、把散落的时间线整理清楚的人——让你在工作间隙刷一眼，就能跟上正在发酵的事。
          </p>
          <p className="mt-3 text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
            站点覆盖明星动态、综艺爆料、影视内幕、音乐现场、网红圈与时尚潮流六大方向。比起抢一个耸动的标题，我们更在意这条瓜是否讲得清楚、经不经得起回看。
          </p>

          <dl className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2">
            {principles.map((item) => (
              <div key={item.title} className="flex gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-xl text-primary-600">
                  <i className={item.icon} aria-hidden="true" />
                </span>
                <div>
                  <dt className="text-sm font-medium text-foreground-900">{item.title}</dt>
                  <dd className="mt-1 text-xs leading-6 text-foreground-600">{item.text}</dd>
                </div>
              </div>
            ))}
          </dl>
        </div>

        <div className="relative">
          <div className="h-[300px] w-full overflow-hidden rounded-lg md:h-[420px]">
            <img
              src="https://readdy.ai/api/search-image?query=Cozy%20modern%20media%20studio%20interior%20with%20warm%20ambient%20lamps%2C%20large%20monitors%20glowing%20softly%2C%20dark%20wood%20and%20cream%20tones%2C%20cinematic%20warm%20lighting%2C%20inviting%20editorial%20atmosphere%2C%20no%20people&width=1000&height=750&seq=heigua-about-01&orientation=landscape"
              alt="黑瓜吃料编辑工作区的暖光环境"
              className="h-full w-full object-cover object-top"
            />
          </div>
          <div className="absolute -bottom-5 left-5 right-5 rounded-lg border border-background-200 bg-background-50 p-5 sm:left-8 sm:right-auto sm:w-72">
            <p className="font-heading text-2xl text-primary-600">24 / 7</p>
            <p className="mt-1 text-xs leading-6 text-foreground-600">蹲点不打烊。别人睡觉的时间，恰好是很多瓜最活跃的时间段。</p>
          </div>
        </div>
      </div>
    </section>
  );
}